<div class="card">
  <div class="card-header d-flex align-items-baseline justify-content-between">
    {{ title }}
    <span *ngIf="!readonly" class="pull-right">
      <app-modal-select
        title="Suchen und hinzufügen"
        (selected)="addedCertificateSelected.emit($event)">
        <app-certificate-list #selectComponent [selectMode]="true"></app-certificate-list>
      </app-modal-select>
      <button type="button" (click)="createNewElement()" class="ms-2 btn btn-outline-secondary" title="Neu anlegen und übernehmen">
        <i class="fa fa-plus"></i>
      </button>
    </span>
  </div>

  <div class="card-body" *ngIf="data.length > 0">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>ID</th>
          <th>
            Seriennummer (dez/hex)
          </th>
          <th>
            Antragssteller
          </th>
          <th>
            Aussteller
          </th>
          <th>
            Gültig von
          </th>
          <th>
            Gültig bis
          </th>
          <th class="right-align">Aktionen</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let certificate of data">
          <td>
            {{ certificate.id }}
          </td>
          <td>
            {{ certificate.serialNumber }} / {{ certificate.serialNumberInHex }}
          </td>
          <td>
            <div *ngFor="let entry of (certificate.subjectX500Principal | principalName: true)">
              {{ entry }}
            </div>
          </td>
          <td>
            <div *ngFor="let entry of (certificate.issuerX500Principal | principalName: true)">
              {{ entry }}
            </div>
          </td>
          <td>
            {{ certificate.validFrom }}
          </td>
          <td>
            {{ certificate.validTo }}
          </td>
          <td class="right-align">
            <a title="Anzeigen" [routerLink]="['/schluessel/zertifikate', certificate.id]" class="btn btn-outline-secondary btn-sm me-1">
              <i class="fa fa-eye"></i>
              <span class="visually-hidden">Zertifikat anzeigen</span>
            </a>
            <a *ngIf="!readonly"
              title="Aus Leser-Liste löschen"
              (click)="onDelete($event, certificate)"
              href="#"
              class="btn btn-danger btn-sm"
            >
              <i class="fa fa-trash-o"></i>
              <span class="visually-hidden">Zertifikat aus Leser-Liste löschen</span>

            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="card-body" *ngIf="data.length === 0">
    <div class="alert alert-info">
      Es wurden keine Einträge gefunden.
    </div>
  </div>
</div>
